import Configuration from './Configuration'

import './style.scss'

export { Configuration }
export default Configuration
